import { ASSETS_PATH } from '@anecdotes/design-system/injection-tokens';
import { Component, EventEmitter, HostBinding, Inject, NgZone, Output } from '@angular/core';
import { SVGRendererConfig, AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-confetti-animate',
  templateUrl: './confetti-animate.component.html',
  styleUrls: ['./confetti-animate.component.scss'],
  standalone: false,
})
export class ConfettiAnimateComponent {
  @HostBinding('class')
  private readonly classes = 'w-full h-full';

  @Output()
  completeAnimation: EventEmitter<any> = new EventEmitter();

  options: AnimationOptions = {
    loop: false,
    path: `${this.assetsPath}/animations/confetti.json`,
    autoplay: false,
    rendererSettings: {
      svg: {
        preserveAspectRatio: 'none',
        filterSize: {
          width: '100%',
          height: '100%',
        },
        className: 'confetti-svg-animation-transform',
      } as SVGRendererConfig,
    }['svg'],
  };

  private animationItem: AnimationItem;

  constructor(@Inject(ASSETS_PATH) private assetsPath: string, private ngZone: NgZone) {}

  animationCreated(animationItem: AnimationItem): void {
    this.animationItem = animationItem;
  }

  domLoaded(): void {
    this.ngZone.runOutsideAngular(() => {
      this.animationItem.play();
    });
  }
}
